/**
 * @file RequiredElementLock.tsx
 * @description Полоса обязательного элемента шаблона страницы товара
 * (phase19.16 Р2а; uiux-design-r2a §3, §6; SB34 + решение 2026-10-12):
 * «Обязательный элемент: по закону виден всегда. Переставлять можно» и
 * почему его нельзя удалить. Галочки устройств такого элемента отмечены и
 * неактивны (`ElementPlacementGroup locked`), «Удалить» в «⋯» серое.
 */

import { Lock } from "lucide-react";

import { requiredRemoveText } from "../../../../lib/site-builder/product-element-meta";

export function RequiredElementLock({ kind }: { kind: string }) {
  return (
    <div role="note" className="flex items-start gap-2 rounded-md border-l-4 border-primary bg-primary/8 px-3 py-2">
      <Lock aria-hidden className="mt-0.5 size-4 shrink-0 text-primary" />
      <div className="flex min-w-0 flex-col gap-1">
        <p className="type-body font-medium text-on-surface">Обязательный элемент: по закону виден всегда. Переставлять можно.</p>
        <p className="type-caption text-on-surface-variant">{requiredRemoveText(kind)}</p>
      </div>
    </div>
  );
}
